import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

const AppContact = ({ appName, privacyLink, tosLink }) => {
  return (
    <section className="app-contact">
      <div className="container">
        <h2 className="section-title">Get in Touch</h2>
        <div className="contact-content">
          <p>Have questions about {appName}? Want to report a bug or suggest a feature?</p>
          <div className="contact-buttons">
            <Link to="/contact" className="btn btn-primary">
              <i className="fas fa-envelope"></i>
              Contact Developer
            </Link>
            <Link to={privacyLink} className="btn btn-outline">
              <i className="fas fa-shield-alt"></i>
              Privacy Policy
            </Link>
            <Link to={tosLink} className="btn btn-outline">
              <i className="fas fa-file-contract"></i>
              Terms of Service
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

AppContact.propTypes = {
  appName: PropTypes.string.isRequired,
  privacyLink: PropTypes.string.isRequired,
  tosLink: PropTypes.string.isRequired
};

export default AppContact;
